import { render } from "./Login.vue?vue&type=template&id=efbf9682"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Desktop\\doc\\MedRemind Project\\medremind-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__